import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { colors } from 'styles/colors';
import DeleteRegistryButton from '../DeleteRegistryButton/DeleteRegistryButton';
import { useRegistryContext } from 'context/RegistryContext';
import useGlobalStyles from 'styles/globalStyles';
import { useNavigate } from 'react-router-dom';
import CalendarIcon from 'icons/CalendarIcon';
import CustomText from 'components/common/CustomText/CustomText';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import EditIcon from 'icons/EditIcon';
import { hexWithOpacity } from 'common/utils';

export default function RegistryOptions() {
  const { registry, refetch } = useRegistryContext();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleInvitationsClick = () => {
    navigate('invitations');
  }

  const handleCollaboratorsClick = () => {
    navigate('collaborators');
  }

  const handleEditClick = () => {
    navigate('edit');
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>

      <IconButton onClick={handleClick} sx={{ padding: 0 }} disableRipple>
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >
          {/* Collaborators */}
          <IconButton
            onClick={handleCollaboratorsClick}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <GroupOutlinedIcon sx={{ color: hexWithOpacity(colors.black, 0.75), fontSize: 19.5 }} />
            </Box>
            <CustomText text="Collaborators" ml="5px" color={colors.black} />
          </IconButton>

          {/* Invitations */}
          <IconButton
            onClick={handleInvitationsClick}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <CalendarIcon color={colors.black} />
            </Box>
            <CustomText text="Invitations" ml="5px" color={colors.black} />
          </IconButton>


          {/* Edit */}
          <IconButton
            onClick={handleEditClick}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <EditIcon color={hexWithOpacity(colors.black, 0.65)} />
            </Box>
            <CustomText text="Edit" ml="5px" color={colors.black} />
          </IconButton>

          {/* Delete */}
          <DeleteRegistryButton
            registryId={registry?.id}
            registryName={registry?.name}
            refetch={refetch}
            onClose={() => setAnchorEl(null)} />


        </Box>
      </Popover>
    </div>
  );
}
